module.exports = __webpack_public_path__ + "img/scenario-reports.bcc11901.webp";